import gsap, { Power2 } from 'gsap';

import { isSmartphone } from '../_app/cuchillo/core/Basics';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import { GetBy, C } from '../_app/cuchillo/core/Element';
import Default from './Default';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { OLMaps } from '../components/OLMaps';
import Language from '../_app/cuchillo/utils/Language';
import { Functions } from '../_app/cuchillo/utils/Functions';

export default class Results extends Default {
  _title;
  _holder;
  _noResults;

  isFilled = false;

  _calls = {
    goHome: () => {
      window.location.href = Language.actual === Language.default ? '/' : '/' + Language.actual;
    },
    readURL: () => {
      const params = new URLSearchParams(window.location.search);

      let query, queryString = '';
      for (const [key, value] of params.entries()) {
        if (key === 'q') {
          query = value;
          queryString = decodeURIComponent(value);
        }
      }

      if (!query && this.isFilled) this._calls.goHome();

      console.log('Query', query);

      this._title.innerHTML = queryString;
      this._calls.getFromAPI(query);
    },
    setLangUrl: () => {
      const params = new URLSearchParams(window.location.search);
      const otherLang = GetBy.selector('#Sidemenu [data-hreflang]:not(.--is-active)')[0];

      for (const [key, value] of params.entries()) {
        if (key === 'q') {
          otherLang.href += '?' + key + '=' + value
        }
      }
    },
    getFromAPI: query => {
      const locale = Language.actual === Language.default ? '' : `&lang=${Language.actual}`;

      fetch(`https://open.cuchillo-black.tools/wp-json/wp/v2/buildings?status=publish&search=${encodeURIComponent(query)}${locale}`)
        .then(response => {
          response.json().then(buildings => {
            this._calls.buildHTML(buildings);
          });
        }).catch(err => {
          console.log(err);
        })
      fetch(`https://open.cuchillo-black.tools/wp-json/wp/v2/activities?status=publish&search=${encodeURIComponent(query)}${locale}`)
        .then(response => {
          response.json().then(activities => {
            this._calls.buildHTML(activities);
          });
        }).catch(err => {
          console.log(err);
        })
    },

    buildHTML: buildings => {
      if (buildings.length > 0 && !this.isFilled) this._noResults.remove();

      for (let i = 0; i < buildings.length; i++) {
        const build = buildings[i];
        const link = build.link.replace('https://open.cuchillo-black.tools/', '/');
        const title = build.title.rendered;

        const buildString = `
            <a class="card card-building" href="${link}" data-coords data-lat="${build.acf.lat}" data-lng="${build.acf.lng}" data-title="${title}">
               <div class="bg" data-scroll-displace="" style="transform: translate3d(0px, 1.48861px, 0px);">
                   <img class="main-image" alt="${title}" src="${build.acf.main_image.sizes['@2x']}" />
               </div>
    
              <div class="title-list">${title}</div>
              <div class="address">${build.acf.address}</div>

              <div class="info">
                  ${(build.acf.inscripcion_necesaria || build.acf['150_anos']) ? `
                      <div class="--top --left --column">
                        ${build.acf.inscripcion_necesaria ? `
                            <span class="icono-text --euskadi">
                              <span class="icono">
                                <svg viewBox="0 0 48 48"><use xlink:href="/assets/images/sprite.svg#icono-inscripcion"></use></svg>
                              </span>
                              <span>Inscripción</span>
                            </span>
                        ` : ''}
                        ${build.acf['150_anos'] ? `
                            <span class="icono --large">
                              <svg viewBox="0 0 48 48"><use xlink:href="/assets/images/sprite.svg#150-anos"></use></svg>
                            </span>
                        ` : ''}
                     </div>
                    ` : ''}
                  ${build.acf.high_demand ? `
                      <div class="--top --right --row">
                          <span class="icono --white">
                              <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                                  viewBox="0 0 48 48" style="enable-background:new 0 0 48 48;" xml:space="preserve">
                                  <style type="text/css">
                                      .st00101010{fill:#FF4BA9;}
                                      .st11010101010101{fill:#1D1D1B;}
                                  </style>
                                  <g>
                                      <g>
                                          <path class="st00101010" d="M23.9,45.3c-8.6,0-15.9-6.5-17.1-15.1C6,23.9,8.3,18.3,13.4,14c0.7-0.6,1.6-0.9,2.5-0.9c0.7,0,1.4,0.2,2,0.6
                                              c-0.1-1.7,0-3.1,0.3-4.5c0.4-1.8,1-3.2,2-4.3c0.5-0.5,1-0.9,1.4-1.3C22.4,3,23.2,2.7,24,2.7c0.7,0,1.4,0.2,2,0.6
                                              c1.3,0.8,2,2.1,1.8,3.7l0,0.3c0,0.3,0,0.7-0.1,1c0,0.5,0.1,1.1,0.9,1.7c0.7,0.6,1.3,1,1.8,1.3c3.2,1.8,5.5,3.7,7.2,5.9
                                              c3.5,4.6,4.5,10.6,2.7,16.1c-1.8,5.5-6.3,9.8-11.9,11.3C27,45.1,25.5,45.3,23.9,45.3C24,45.3,23.9,45.3,23.9,45.3z"/>
                                          <path class="st00101010" d="M24,5.4c0.2,0,0.4,0.1,0.6,0.2c0.4,0.2,0.6,0.6,0.6,1.1l0,0.3c0,0.4-0.1,0.8-0.1,1.1c0,1.5,0.6,2.8,1.9,3.9
                                              c0.8,0.7,1.5,1.2,2.2,1.6c2.8,1.6,4.9,3.2,6.4,5.2c3,3.9,3.8,9,2.3,13.6c-1.6,4.7-5.3,8.2-10,9.5c-1.2,0.3-2.5,0.5-3.8,0.5h0
                                              c-7.2,0-13.4-5.5-14.4-12.7c-0.7-5.4,1.2-10.1,5.6-13.8c0.3-0.2,0.5-0.3,0.8-0.3c0.2,0,0.4,0.1,0.6,0.2c0.5,0.3,0.5,0.9,0.5,1.3
                                              c-0.1,0.4-0.1,0.7-0.2,1c-0.2,1.4-0.2,2.9,0.2,4.3c0.4,1.5,1.8,2.6,3.3,2.6c0.2,0,0.4,0,0.6-0.1c0.9-0.2,1.4-0.8,1.5-1.6
                                              c0-0.6,0-1.1-0.2-1.6c-0.8-2.7-1.2-4.9-1.5-7c-0.2-2-0.2-3.7,0.2-5.1c0.3-1.3,0.7-2.3,1.4-3.1c0.3-0.3,0.7-0.6,1-0.9
                                              C23.5,5.5,23.8,5.4,24,5.4 M24,0c-1.4,0-2.7,0.4-3.9,1.3c-0.6,0.4-1.2,0.9-1.9,1.7c-1.3,1.5-2.2,3.3-2.7,5.6
                                              c-0.1,0.6-0.2,1.2-0.3,1.8c-1.3,0.1-2.6,0.7-3.6,1.5c-5.9,4.9-8.5,11.4-7.5,18.7C5.5,40.5,14,48,23.9,48c1.8,0,3.6-0.2,5.3-0.7
                                              c6.5-1.8,11.6-6.7,13.8-13.1c2.1-6.4,0.9-13.4-3.1-18.7c-2-2.6-4.5-4.7-8.1-6.7C31.4,8.7,31,8.4,30.5,8c0-0.2,0-0.3,0-0.5l0-0.4
                                              c0.2-2.6-1-4.9-3.2-6.2C26.4,0.3,25.2,0,24,0L24,0z"/>
                                      </g>
                                      <path class="st11010101010101" d="M23.9,42.9c-7.2,0-13.4-5.5-14.4-12.7c-0.7-5.4,1.2-10.1,5.6-13.8c0.3-0.2,0.5-0.3,0.8-0.3
                                          c0.2,0,0.4,0.1,0.6,0.2c0.5,0.3,0.5,0.9,0.5,1.3c-0.1,0.4-0.1,0.7-0.2,1c-0.2,1.4-0.2,2.9,0.2,4.3c0.4,1.5,1.8,2.6,3.3,2.6
                                          c0.2,0,0.4,0,0.6-0.1c0.9-0.2,1.4-0.8,1.5-1.6c0-0.6,0-1.1-0.2-1.6c-0.8-2.7-1.2-4.9-1.5-7c-0.2-2-0.2-3.7,0.2-5.1
                                          c0.3-1.3,0.7-2.3,1.4-3.1c0.3-0.3,0.7-0.6,1-0.9c0.2-0.2,0.4-0.2,0.7-0.2c0.2,0,0.4,0.1,0.6,0.2c0.4,0.2,0.6,0.6,0.6,1.1l0,0.3
                                          c0,0.4-0.1,0.8-0.1,1.1c0,1.5,0.6,2.8,1.9,3.9c0.8,0.7,1.5,1.2,2.2,1.6c2.8,1.6,4.9,3.2,6.4,5.2c3,3.9,3.8,9,2.3,13.6
                                          c-1.6,4.7-5.3,8.2-10,9.5C26.6,42.7,25.3,42.9,23.9,42.9L23.9,42.9z M13.7,21.4c-1.5,2.3-2.1,4.8-1.9,7.5
                                          c0.4,6.5,5.7,11.6,12.1,11.6c0.9,0,1.7-0.1,2.6-0.3c4.6-1,7.8-4,9.2-8.5c1.4-4.5,0.4-8.6-3-12.2c-1.3-1.4-2.9-2.5-4.8-3.6
                                          c-1-0.5-1.9-1.2-2.7-1.9c-0.4-0.4-0.7-0.8-1.1-1.2c-0.2-0.2-0.3-0.5-0.5-0.8c-0.1-0.2-0.3-0.5-0.4-0.6c-0.3-0.2-0.3,0.7-0.3,0.8
                                          c0,0.4,0,0.8,0,1.2c0,0.8,0.1,1.6,0.1,2.4c0.2,1.5,0.5,3.1,0.9,4.5c0.1,0.3,0.2,0.7,0.3,1c0.2,0.7,0.3,1.2,0.4,1.7
                                          c0.1,2.4-1.1,4-3.2,4.5c-0.4,0.1-0.8,0.1-1.2,0.1c-2,0-3.9-1.1-4.9-2.9c-0.7-1.2-0.9-2.6-0.9-3.9l0-0.5L13.7,21.4z"/>
                                  </g>
                              </svg>
                          </span>
                      </div>
                  ` : ''}
                  <div class="--bottom --left --column">
                      ${build.acf.dni ? `
                          <span class="icono-text --white">
                            <span class="icono">
                              <svg viewBox="0 0 48 48"><use xlink:href="/assets/images/sprite.svg#icono-dni"></use></svg>
                            </span>
                            <span>Dni</span>
                          </span>
                      ` : ''}
                      ${build.acf.accessible ? `
                        <span class="icono-text --white">
                          <span class="icono">
                            <svg viewBox="0 0 13 16"><use xlink:href="/assets/images/sprite.svg#icono-accesible"></use></svg>
                          </span>
                          <span>Accesible</span>
                        </span>
                      ` : ''}
                      ${build.acf.minutes_visit ? `
                          <span class="icono-text --white">
                            <span class="icono">
                              <svg viewBox="0 0 48 48"><use xlink:href="/assets/images/sprite.svg#icono-time"></use></svg>
                            </span>
                            <span class="--capitalize">${build.acf.minutes_visit} Min.</span>
                          </span>
                      ` : ''}
                      ${build.acf.people_group ? `
                          <span class="icono-text --white">
                            <span class="icono">
                              <svg viewBox="0 0 48 48"><use xlink:href="/assets/images/sprite.svg#icono-people"></use></svg>
                            </span>
                            <span>${build.acf.people_group}</span>
                          </span>
                      ` : ''}
                  </div>
                  <div class="title-mobile" data-remove-desktop>
                      <span>${title}</span>
                  </div>
              </div>
            </a>
        `;

        const li = document.createElement('li');
        li.innerHTML = buildString

        this._holder.appendChild(li);
      }

      const selector = isSmartphone ? "data-remove-smartphone" : "data-remove-desktop";
      [...GetBy.selector(`[${selector}]`)].map((item) => C.remove(item));

      Scroll.resize();

      OLMaps.dispose();
      OLMaps.init();
    }
  }

  constructor() {
    super();

    document.documentElement.classList.add('--project');

    this._title = GetBy.class('__title', this.container)[0];
    this._holder = GetBy.class('__holder', this.container)[0];
    this._noResults = GetBy.class('__empty', this.container)[0];

    this._calls.readURL();
    this._calls.setLangUrl();
  }

  afterHide() {
    super.afterHide();
    document.documentElement.classList.remove('--project');
  }
}

ControllerPage._addPage('results', Results);